import { FC, useContext, useState } from 'react'
import {
  Box,
  Typography,
  IconButton,
  Button,
  Modal,
  TextField,
} from '@mui/material'
import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined'
import CloseIcon from '@mui/icons-material/Close'
import SaveIcon from '@mui/icons-material/Save'
import { useToast } from '../../../../contexts/toast.context'
import { PlaybookContext } from '../../../../contexts/playbooks.context'
import { updatePlaybook } from '../../../../services/playbook.service'
import { IPlaybook } from '../../../../types/playbook.type'

import styles from './styles.module.scss'

interface IProps {
  playbook: IPlaybook
  onClose: () => void
}

const PlaybookEditModal: FC<IProps> = ({ playbook, onClose }) => {
  const [name, setName] = useState(playbook.name)
  const [slug, setSlug] = useState(playbook.slug)

  const { showToast } = useToast()

  const { refreshList } = useContext(PlaybookContext)

  const handleEdit = async () => {
    const data = await updatePlaybook({
      ...playbook,
      name,
      slug,
    })

    if (data.success) {
      refreshList()
      showToast('success', data.message)
      onClose()
    }
  }

  return (
    <Modal className={styles.modal} open onClose={onClose}>
      <Box className={styles.modalContent}>
        <Box>
          <Box className={styles.header}>
            <Typography data-testid="title" className={styles.title}>
              Edit Playbook: {playbook.name}
            </Typography>
            <IconButton data-testid="closeButton" onClick={onClose}>
              <CloseOutlinedIcon />
            </IconButton>
          </Box>
          <Box className={styles.selects}>
            <TextField
              label="Name"
              value={name}
              onChange={(evt) => setName(evt.target.value)}
            />
          </Box>
          <Box className={styles.selects}>
            <TextField
              label="Slug"
              value={slug}
              onChange={(evt) => setSlug(evt.target.value)}
            />
          </Box>
          <Box className={styles.actions}>
            <Button onClick={onClose} startIcon={<CloseIcon />}>
              Cancel
            </Button>
            <Button
              onClick={handleEdit}
              variant="contained"
              startIcon={<SaveIcon />}
            >
              Save
            </Button>
          </Box>
        </Box>
      </Box>
    </Modal>
  )
}

export default PlaybookEditModal
